import React, { useEffect, useState, useCallback } from 'react';
import DOMPurify from "dompurify";
import * as _ from 'lodash';

import './SearchBox.scss';
import { Subject, interval } from 'rxjs';
import { debounce } from 'rxjs/operators';

interface SearchBoxProps {
  placeholder: string;
  text: string;
  onChangeText: any;
}

const SearchBox = (props: SearchBoxProps) => {

  const [inputValue, setInputValue] = useState(props.text);
  const onSearch$ = new Subject();

  useEffect(() => {
    const sub = onSearch$.pipe(debounce(() => interval(500))).subscribe((value) => {
      if (props.onChangeText) {
        props.onChangeText(value);
      }
    });

    return () => sub.unsubscribe();
  }, [])


  const handleInputChange = useCallback(
    event => {
      // sanitize the input a little
      const value = DOMPurify.sanitize(event.target.value);
      setInputValue(value);
      onSearch$.next(value);
    }, [setInputValue]);



  return (
    <div className="search-box">
      <div className="lens-logo"></div>
      <input
        type="text"
        value={inputValue}
        onChange={handleInputChange}
        placeholder={props.placeholder || 'Search...'}
      />
    </div>
  );
}

export default SearchBox;